module.exports = __webpack_public_path__ + "static/media/no-campaign@2x.2913e298.png";